import { useState,useRef} from 'react';
import { AgGridReact } from 'ag-grid-react';
import IPRestrictionTemplateContainer from './IPRestrictionTemplateContainer';
import IPRestrictionContainer from './IPRestrictionContainer';
import UserStoreDropdown from '../common/UserStoreDropdown';
import {
  StyledTextButton,
  StyledIconSettings,
  StyledIconFileDownload
} from './StyledComponents';
import {
  Toast,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS,
  BUTTON_VARIANTS,
  BUTTON_ICON_COLORS,
  IconCancelOutlined,
} from 'cdk-radial';
import moment from 'moment';
import { BUTTON_SIZES,IconSettings } from "cdk-radial";
import IPRestrictionSettingsDialog from './IPRestrictionSettingsDialog';
import { useIamUserProfileStore } from '../../Store';

export function dateValueFormatter(value: any) {
    return value ? moment.utc(
          value,
        'dddd, MMMM DD, YYYY at h:mm:ss A Z'
    ).local().format('MM/DD/YYYY h:mm A') : "";

};

export default function IPRestrictionMainContainer(): JSX.Element {

  const [isTemplateOpen, setTemplateOpen] = useState(false);
  const gridRef = useRef<AgGridReact>(null);
  const [storeId, setStoreId] = useState('');
  const [storeName, setStoreName] = useState('');
  const [showSettings, setShowSettings ] = useState(false);
  const iamUserInfo = useIamUserProfileStore((state: any) => state.iamUserInfo);
  const enterpriseId = iamUserInfo?.fullUser
    ? iamUserInfo?.fullUser?.enterprise?.id
    : null;

  const onCloseTemplate = () => setTemplateOpen(false);
  const onHandleOpenTemplate = () => {setTemplateOpen(true); resetToastState(); };
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState('');
  const [toastMsg, setToastMsg] = useState<string>('');

  const resetToastState = () => {
    setToastMsg('');
    setToastType('');
    setShowToast(false);
  };

  const setToast = (msg='',type='',toast=false) =>{
    setToastMsg(msg);
    setToastType(type);
    setShowToast(toast);
    setTemplateOpen(false);
  }

  const setUserExemptToast = (id='',type='',msg='') =>{
    setToastMsg(msg);
    setToastType(type);
    setShowToast(true);
  }


  const handleSelectedOption = (storeName: string, storeId: string) => {
    setStoreId(storeId);
    setStoreName(storeName);
    setTemplateOpen(false);
  };

  const handleDefaultStoreSelection = (storeName: string, storeId: string) => {
    setStoreId(storeId);
    setStoreName(storeName);
  };

  const handleClear = () => {
    setStoreId("");
    setStoreName("");
    setTemplateOpen(false);
  };

  const onExport = () => {
      gridRef?.current?.api?.exportDataAsExcel({
        fileName: 'ip-access-list.xlsx',
        processCellCallback: (params) => {
         let column = params.column;

         if (column.getColId() === 'allowedIps') {
            const data = params.node?.data;
            if (!data) return '';
            let value = data.allowedIps || '';
            const [assignedTemplateId] = data.templates || [];
            const availableTemplates = data.availableTemplates || [];
            const assignedTemplate = availableTemplates.find(
              (template: any) => template.id === assignedTemplateId
            );
            const templateIps = assignedTemplate?.allowedIps;
            if (templateIps) {
              value = value.length > 0 ? `${templateIps},${value}` : templateIps;
            }
            return value;
        }

        if (column.getColId() === 'allowedIpRange') {
            const data = params.node?.data;
            if (!data) return '';

            const userRanges = data.allowedIpRange || [];
            let result = userRanges.map((item: any) => `${item.begin} - ${item.end}`).join(',');

            const [assignedTemplateId] = data.templates || [];
            const availableTemplates = data.availableTemplates || [];

            const assignedTemplate = availableTemplates.find(
              (template: any) => template.id === assignedTemplateId
            );

            const templateRanges = assignedTemplate?.allowedIpRange || [];

            if (templateRanges.length > 0) {
              const templateResult = templateRanges
                .map((item: any) => `${item.begin} - ${item.end}`)
                .join(',');
              result = result.length > 0 ? `${templateResult},${result}` : templateResult;
            }

            return result;
        }

        if(column.getColId() === 'updatedOn'){
            return dateValueFormatter(params.value);
        }

         return params.value;

        }
      });
  };

  return (
    <>
      <div style={{marginBottom:'10px'}}>
        <UserStoreDropdown
          handleDefaultOption={handleDefaultStoreSelection}
          handleSelectedOption={handleSelectedOption}
          handleClear={handleClear}
        />
      </div>

      {storeId && (
        <div style={{ marginBottom: '10px', display:'flex', flexDirection:'row-reverse' }}>
          <StyledIconFileDownload onClick={()=>onExport()} data-testid='export-ip-config-icon' ></StyledIconFileDownload>
          <StyledIconSettings
            icon={<IconSettings />}
            size={BUTTON_SIZES.SMALL}
            dataTestId="ip-access-settings-button"
            data-testid="ip-access-settings-button"
            onClick={() => {setShowSettings(true)}}
            text=""
          />
          <StyledTextButton
            dataTestId="ip-template-button"
            iconColor="primary"
            onClick={onHandleOpenTemplate}
            text={'IP Template'}
          />
        </div>
      )}

      {!storeId ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
          color: '#666',
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
        }}>
          Please select a store to view IP Access Configurations.
        </div>
      ) : (
        <>
        <IPRestrictionSettingsDialog 
              enterpriseId={enterpriseId}
              storeId={storeId}
              isOpen={showSettings} 
              onClose={() => setShowSettings(false)}
              openToast={(id:string,type:string,msg:string) => setUserExemptToast(id,type,msg)}
            />
            <IPRestrictionContainer
              setToast={setToast}
              isTemplateOpen={isTemplateOpen}
              gridRef={gridRef}
              storeId={storeId}
              storeName={storeName}
            />
          </>
      )}

      {isTemplateOpen && storeId && (
        <div style={{ marginTop: '20px' }}>
          <IPRestrictionTemplateContainer
            onClose={onCloseTemplate}
            isTemplateOpen={isTemplateOpen}
            setToast={setToast}
            storeId={storeId}
          />
        </div>
      )}

      {showToast && (
        <Toast
          id="ip-access-toast"
          datatestid="ip-access-toast"
          position={TOAST_POSITIONS.FIXED}
          style={{
            marginTop: '70px',
            zIndex: 1003,
          }}
          variant={toastType === 'Error' ? 'negative' : 'positive'}
          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
          onVisibilityDurationEnd={() => {
            resetToastState();
          }}
          actions={[
            {
              onClick: () => {
                resetToastState();
              },
              variant: BUTTON_VARIANTS.ICON,
              icon: <IconCancelOutlined />,
              iconColor: BUTTON_ICON_COLORS.GRAY,
              text: '',
            },
          ]}
          content={toastMsg}
        />
      )}

    </>
  );
}